
bq.selectboxData = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this._initData = false;
  this._currentCall = {};
};

bq.selectboxData.DEFAULTS = {
  input: 'input.selectbox-data',
  formatInitData: false, //[{text: '', data: {text: '', data: data}}]
  initData: false,
  ajaxUrl: false,
  urlSingle: false,
  ajaxResponse: 'json',
  updateInput: false,
  updateEvent: false, //{event: '', data: id} - data is the field to send with event
  minSearchLength: 1,
  placeholder: false,
  formatResults: false,
  formatSelection: false,
  initSelection: false,
  updateSelection: false,
  escapeMarkup: function(m) { return m; },
  advanced: false,
  selectId: false,
  parentFilter: false,
  parentContainer: false,
  clear: false,
  cache: true
};

bq.selectboxData.cache = {};

bq.selectboxData.prototype = {
  init: function(ignore) {
    bq.debug.log("Selectbox Data : init()", this.$element);

    if(!this.options.formatInitData) { this.options.formatInitData = this._formatInitData; }
    if(!this.options.initSelection) { this.options.initSelection = this._initSelection; }
    if(!this.options.formatResults) { this.options.formatResults = this._formatResults; }
    if(!this.options.formatSelection) { this.options.formatSelection = this._formatSelection; }

    if(!ignore) {
        this.$element.on('bq.selectboxdata.update', {context:this}, this._catchUpdateEvent);
        this.$element.on('bq.selectboxdata.resetInit', {context:this}, this._resetInitData);
        this.$element.on('bq.selectboxdata.updateValue', {context:this}, this._catchUpdateValueEvent);
        this.$element.on('bq.selectboxdata.enableSelectBox', {context:this, 'enable':true}, this._catchSwitchEnableSelectBox);
        this.$element.on('bq.selectboxdata.disableSelectBox', {context:this, 'enable':false}, this._catchSwitchEnableSelectBox);

        var parentInput = this._getParent();
        if(parentInput) {
          var parentInputSelector = '#' + parentInput.attr('id');
	        $(this.options.parentContainer).on('change', parentInputSelector, {context:this}, this._catchParentChangeEvent);
        }

        this.input().on('select2-removed', {context:this}, this._catchEventRemove);
    }

    $(this.$element.closest('.select-group').find('.select-group__return-default')).on('click', {context: this, return: true}, this._catchUpdateEvent);

    this._ajaxCall = this._ajaxCall.bind(this);
    this._createSelect();
    this._processSelect();
  },

  _catchSwitchEnableSelectBox: function (e, data) {

      var $this = e.data.context;
      var enable = e.data.enable;
      var input = $this.input();

      if ($this._getParent()) {
          var val = $this._getParentFilter();
          if (!val || typeof val == 'object') {
              input.select2('val', false, true);
          } else {
              if($this.options.autoInitSearch) {
                  input.select2("search","");
                  enable = true;
              }
          }
      }
      input.select2("enable", enable);
  },

  _createSelect: function() {
    var $this = this;
    var input = this.input();
    var $options = {};

    if(input.is('select')) {
        $options = {
          allowClear: this.options.clear,

          containerCssClass: 'select2-form-element'

        };
    } else {

        $options = {
          allowClear: this.options.clear,
          formatSelection: this.options.formatSelection,
          initSelection : this.options.initSelection,
          escapeMarkup: this.options.escapeMarkup,
          containerCssClass: 'select2-form-element',
          formatResult: function(item) { return item.text;}
        };

    }


    if(this.options.ajaxUrl) {

      $options.query = this._optionQuery.bind($this);
      // $options.ajax = {
      //   url: this.options.ajaxUrl,
      //   minimumInputLength: this.options.minSearchLength,
      //   dataType: this.options.ajaxResponse,
      //   results: this.options.formatResults.bind(this),
      //   data: function (term, page) {return {q: term}}
      // }
    } else {
      if($this.options.initData) {
          $options.data = $this.options.formatInitData($this.options.initData, $this);
      }

      $options.minimumResultsForSearch = -1;
    }

    if(this.options.noSearch) {
       $options.minimumResultsForSearch = -1;
    }

    if(this.options.advanced) {
      $options = $.extend($options, this.options.advanced);
    }

    // trim label for correct browser tooltip dimensions
    var $label = $(this.$element).find('label');
    if( $label.length ){
        $label.html( $.trim($label.prop('innerHTML').replace(/\s\s+/g, ' ')) );
    }

    input.select2($options);
  },

  input: function() {
      if (typeof (this._input) == 'undefined') {
          this._input = this.$element.find(this.options.input);
      }
      return this._input;
  },

  _processSelect: function() {

    var enable = true;
    var input = this.input();

    if(this.options.advanced.enable === false) { enable = false; }

    if(this._getParent()) {
        var val = this._getParentFilter();

        if(!val || typeof val == 'object') {
            enable = false;
            input.select2('val', false, true);
            if (!enable && input.attr('data-parsley-required') === 'true') {
              input.removeAttr('data-parsley-required');
              input.removeAttr('required');
              input.attr('data-disabled-parsley-required', 'true');
            }

        } else {
            if(this.options.autoInitSearch) {
                input.select2("search","");
                enable = true;
            }
        }

    }

    input.select2("enable", enable);

  },

  _formatInitData: function(tmpData, $this) {
    var data = [];
    var results = {};
    var more = false;
    var page = 1;

    if(!tmpData) { return {more: false, results: []}; }
    if(typeof tmpData !== "object") {
      return; //tmpData = $.parseJSON(tmpData);
    }

    if(tmpData.more) { more = tmpData.more; }
    if(tmpData.page) { page = tmpData.page; }
    if(tmpData.results) { tmpData = tmpData.results; }

    $.each(tmpData, function(k, v) {
      if(v) { //if statement giving me trouble, could cause failure if correct data is not there
        var text = v.text;
        if(v.short) { text = v.short; }

        data.push({ id: v.id, text: text, item: v, selectData: $this.$element });
        if (v.is_selected) {
            $this.options.exclude = v.id;
        }
      }
    });

    $this._initData = data;

    results = {more: more, page: page, results: data};

    return results;
  },

  _initSelection: function(object, callback) {
    var $object = $(object),
        $this = false,
        data = [];

    try {
      $this = $object.closest('[data-bq="selectbox-data"]').data('bq.selectboxData');
    } catch(e) {
      callback(null);
    }

    if($object.val() && $this.options.initData) {
      var initResults = $this.options.initData;

      if(initResults.results) { initResults = initResults.results; }

      var values = $object.val().split(',');
      if (values.length > 1) {
          values.push($object.val());
      }
      $.each(initResults, function(k,v){
        if(v && $.inArray(v.id, values) >= 0) { //see note around if state in _formatResults
          var text = v.text;
          if(v.short) { text = v.short; }

          data.push({ id: v.id, text: text, item: v, selectData: $this.$element });
        }
      });
    }

    if(data.length === 0) {
      data = null;

        if ($this && $this.options.urlInit) {
            $this._getInitValues($object);
            return;
        } else if ($object.val()) {
          if ($this.options.urlSingle) {
            var paramsData = { id:  $object.val() };
            var settings = {
                url: $this.options.urlSingle,
                dataType: "json",
                data: paramsData
            };
            $this._ajaxCall(settings, function(data){
                data.selectData = $this.$element;
                data.action = 'init';
                callback(data);
                $this._processSelect();
            });

            return;
          }
      }
    } else if(data.length === 1) {
      data = data[0];
    }

    callback(data);
  },

  _formatResults: function(object, page, context) {
    var $this = context;
    var data = [];

    if(!$this) {
      $this = this;
    }

    var resultData = object;

    if(object.results) {
        resultData = object.results;
    }

    $.each(resultData, function(k, v) {
      if(v) { //if statement giving me trouble, could cause failure if correct data is not there
        var text = v.text;
        if(v.short) { text = v.short; }

        data.push({ id: v.id, text: text, item: v, selectData: $this.$element, disabled: v.disabled });
      }
    });

    var result = {results: data};

    if(object.more) {
        result.more = object.more;
    }

    if(object.exclude) {
        $this.options.exclude = object.exclude;
    }

    return result;

  },
  _formatSelection: function(object, container) {

    if(!object.item) { return; }

    if(object.selectData) {
      var $this = object.selectData.data('bq.selectboxData');

      if($this.options.updateSelection) {
        bq.helper.waitingForInitSelect2List.push($this.options.updateSelection);
        var $el = $this.$element.find($this.options.updateSelection);
        var html = object.item.text;

        if($el) {

          if(object.item.long) {
            html = object.item.long;
          } else if(object.item.short) {
            html = object.item.short;
          }

          $el.html(html);

          setTimeout(function() {
              bq.helper.throwEvent('select2Inited', $(document), $this.options.updateSelection); //a little hacky but will rerun alot of our JS
          }, 0);
        }
      }

      if($this.options.updateInput && typeof $this.options.updateInput === "object") {
        $.each($this.options.updateInput, function(k,v) {
          if(v.name && v["value"] && object.item[v["value"]]) {
            $('[name="'+v.name+'"]').val(object.item[v["value"]]);
          } else if(v["class"] && v["value"] && object.item[v["value"]]) {
            var $item = $(v["class"]);

            if($item.is(':input')) {
                var input = $this.input();
                var inputVal = input.val();
                $item.each(function() {
                    var el = $(this);
                    el.val(object.item[v["value"]]);

                    if(el.closest('[data-bq="selectbox-data"]')) {

                        bq.helper.throwEvent('bq.selectboxdata.updateValue', el, object.item.id);
                    }
                });
            } else {
                $item.text(object.item[v["value"]]);
            }
          }
        });
      }

      if ($this.options.updateEvent && $this.options.updateEvent.event) {
        var selectedItem = object.item;

          if (selectedItem.item && selectedItem.item.item) {
              selectedItem = selectedItem.item.item;
          } else if (selectedItem.item) {
              selectedItem = selectedItem.item;
          }
        var data = $this.options.updateEvent.data ? selectedItem[$this.options.updateEvent.data] : selectedItem;
        bq.helper.throwEvent($this.options.updateEvent.event, $this.$element, data);
      }

    }

    if(!object.item.short) {
      return object.item.text;
    } else {
      return object.item.short;
    }
  },

  _clearData: function() {
    var $this = this;
    $this.$element.find($this.options.updateSelection).html('');

    if($this.options.updateInput && typeof $this.options.updateInput === "object") {
      $.each($this.options.updateInput, function(k,v) {
        if(v.name && v["value"]) {
          $('[name="'+v.name+'"]').val('');
        } else if(v["class"] && v["value"]) {
          var $item = $(v["class"]);

          if($item.is(':input')) {
              $item.val('');
          } else {
              $item.text('');
          }
        }
      });
    }
  },

  _optionQuery: function(options) {
    var $this = this;

    if(options.term.replace(/ /g, "").length > $this.options.minSearchLength || options.page >= 2) {
        $this._getDataAjax(options);
    } else if($this.options.initData) {
      options.callback($this.options.formatInitData($this.options.initData, $this));
    } else if($this.options.ajaxInit) {
        $this._getDataAjax(options);
    } else {
        options.callback({more: false, results:[]});
    }
  },

  _ajaxCall: function (settings, callback, force)
  {
    var $this = this;
    var hash = JSON.stringify(settings);
    var key = settings.url;

    if ($this._currentCall[key]) {
      $this._currentCall[key].abort();
      $this._currentCall[key] = null;
    }

    if (!bq.selectboxData.cache[hash] || force) {
      bq.selectboxData.cache[hash] = 'pending';
      $this._currentCall[key] = $.ajax($.extend(settings, {
        success: function (data) {
          $this._currentCall[key] = null;
          bq.selectboxData.cache[hash] = data;
          callback(bq.selectboxData.cache[hash]);
        },
        error: function () {
            delete bq.selectboxData.cache[hash];
        }
      }));
    } else if (bq.selectboxData.cache[hash] === 'pending') {
        setTimeout($this._ajaxCall, 500, settings, callback, force);
    } else {
      callback(bq.selectboxData.cache[hash]);
    }
  },

  _getDataAjax: function(options) {
    var $this = this;
    var dataParams = {
        q: options.term,
        p: options.page
    };
    if ($this.options.ajaxData) {
        $.extend(dataParams, $this.options.ajaxData);
    }
    if ($this.options.exclude) {
        $.extend(dataParams, {e: $this.options.exclude});
    }
    var $input = $this.input();

    if($this._getParent()) {
        dataParams.filter = $this._getParentFilter();
    }

    var settings = {
        url: $this.options.ajaxUrl,
        data: dataParams,
        dataType: $this.options.ajaxResponse,
        type: 'get'
    };

    this._ajaxCall(settings, function(data){
        var results = $this.options.formatResults(data, options.page, $this);
        options.callback(results);

        if(data.disable) {
            $input.select2("enable", false);
        } else {
            $input.select2("enable", true);
        }
    });
  },

  _resetInitData: function(e) {
      var $this = e.data.context;
      $this.options.initData = false;
  },

  _catchUpdateEvent: function(e, data) {
    var $this = e.data.context;
    var input = $this.input();

    if (e.data.return) {
      data = $this.options.initData;
    }

    var results = data;
    if(data.results) {  results = data.results }

    $this.options.initData = data;

    var is_selected = 0;
    var is_selected_key = 0;
    $(results).each(function(key, value){
        if (value.is_selected) {
            is_selected = value.id;
            is_selected_key = key;
        }
    });

      if (is_selected) {
          input.val(is_selected);
      } else if (results[0] && (parseInt(results[0]['is_default']) == 1 || parseInt(results[0]['is_default_billing']) == 1)) {
          input.val(results[0]['id']);
      } else {
          input.val('');
      }

    input.trigger('change');

    if (is_selected) {
        $this._formatSelection({ id: results[is_selected_key].id, text: results[is_selected_key].text, item: results[is_selected_key], selectData: $this.$element });
    } else if (results[0] && (parseInt(results[0]['is_default']) == 1 || parseInt(results[0]['is_default_billing']) == 1)) {
        $this._formatSelection({ id: results[0].id, text: results[0].text, item: results[0], selectData: $this.$element });
    } else if($this.options.advanced && $this.options.advanced.multiple) {
        //its multiple...
        $this._formatSelection($this.options.formatInitData($this.options.initData, $this));
    } else {
        //need to clear everything???
        $this._clearData();
    }

    $this._processSelect();

  },

  _catchEventRemove: function(e) {
      let $this = e.data.context;
      if ($this.options.updateEvent && $this.options.updateEvent.event) {
          bq.helper.throwEvent($this.options.updateEvent.event, $this.$element, {});
      }
  },

  _catchUpdateValueEvent: function(e, data) {
    var $this = e.data.context;
    var input = $this.input();

    if(input.select2('val') != data) {
       input.select2('val', data, true);
    }

    $this._processSelect();

    //$this.$element.find($this.options.input).select2('val', data);
    //var input = $this.$element.find($this.options.input);
    //input.val(data.id);
    //$this._formatSelection({ id: data.id, text: data.text, item: data, selectData: $this.$element });
  },

  _getParent: function() {
    var result = null;
    if (this.options.parentFilter && this.options.parentContainer) {
        var parent = $('[data-select-id="' + this.options.parentFilter + '"]', this.$element.closest(this.options.parentContainer));
        result = parent.find(this.options.input);
    }
    return result;
  },

  _getParentFilter: function() {
    var parent = this._getParent();
    return parent ? parent.select2('val') : '';
  },

  _hasSelect2Change: function(e) {
      var nextProp = e.added;
      var prevProp = e.removed;
      if (nextProp === null || prevProp === null) {
          return false;
      }

      if (typeof nextProp !== 'object' || typeof prevProp !== 'object') {
          return false;
      }

      if (typeof nextProp['id'] === 'undefined' || typeof prevProp['id'] === 'undefined') {
          return false;
      }

      return nextProp['id'] !== prevProp['id'];
  },

  _catchParentChangeEvent: function(e) {
    var $this = e.data.context;
    if ($this._getParent().val() === $this._getParent().data('default-value')
        && !$this._hasSelect2Change(e)
    ) {
        /* It prevents triggering an unnecessary chain of events during the accounting initialization */
        $this._processSelect();
        return;
    }

    if ($this._getParentFilter() && $this.options.urlInit) {
        $this._getInitValues(null);
    } else {
        if(!$this.input().val()) {
	        var input = $this.input();
	        input.val('');
	        $this._catchUpdateEvent(e, false);
        } else if(e.added && e.added.action == 'init') {
            return;
        }
    }
    //$this._processSelect();
  },

  _getInitValues: function(object) {
      var $this = this;
      var data = $.extend({}, $this.options.ajaxData);
      if ($this._getParent()) {
          data.filter = $this._getParentFilter();
      }
      if (object && object.val()) {
          data.value_id = object.val();
      }
      var settings = {
          url: $this.options.urlInit,
          dataType: "json",
          data: data
      };
      $this._ajaxCall(settings, function(data) {
          var result = $this.options.formatResults(data, null, $this);
          if (result.results.length) {
              result.results[0].is_selected = true;
              bq.helper.throwEvent('bq.selectboxdata.update', $this.$element, result);

              var select2 = $this.input().data('select2');
              if ($this.options.forceShowSearch || data.allow_search) {
                  select2.opts.minimumResultsForSearch = 0;
                  select2.showSearch(true);
              } else {
                  select2.opts.minimumResultsForSearch = -1;
                  select2.showSearch(false);
              }
          }
      });
  }
};

// SELECTBOX DATA PLUGIN DEFINITION
// =======================

var selectboxDataold = $.fn.selectboxData;

$.fn.selectboxData = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.selectboxData');
    var options = $.extend({}, bq.selectboxData.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.selectboxData', (data = new bq.selectboxData(this, options))); }
    data.init();
  });
};

$.fn.selectboxData.Constructor = bq.selectboxData;

// SELECTBOX DATA NO CONFLICT
// =================

$.fn.selectboxData.noConflict = function () {
  $.fn.selectboxData = selectboxDataold;
  return this;
};

// SELECTBOX DATA DATA-API
// ==============

bq.selectboxDataInit = function() {
  $('[data-bq="selectbox-data"]').each(function () {
    var el = $(this);
    if(el.data('bq.selectboxData')) { return; }
    el.selectboxData(el.data());
  });
};

bq.init.push(bq.selectboxDataInit);

